import RouteFile from "../../apis/wellbeingInitiative";

export default {
  getWellIntiatives({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RouteFile.getWellIntiatives(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  addWellIntiatives({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RouteFile.addWellIntiatives(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editWellIntiatives({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RouteFile.editWellIntiatives(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteWellIntiatives({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RouteFile.deleteWellIntiatives(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
